<script>
    export default {
        name: "Token",
        data() {
            return {
                localStorageItem: 'at'
            }
        },
        computed: {
            appToken() {
                return this.storeToken || this.clientToken;
            },
            clientToken() {
                return window.localStorage.getItem(this.localStorageItem);
            },
            storeToken() {
                return this.$store.getters.token;
            }
        },
        methods: {
            setStoreToken(token) {
                this.$store.commit('setAppToken', token);
                return this.storeToken;
            },
            setLSToken(token) {
                window.localStorage.setItem(this.localStorageItem, token);
            }
        },
    }
</script>